import {getCrossPseudoId, onCrossPseudoIdChange, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {gtag} from "./gtag";

const pushCrossPseudoIdToGtag = (crossPseudoId: string | null): void => {
    gtag("set", "user_properties", {cross_pseudo_id: crossPseudoId});
};

export const syncCrossPseudoIdWithGa4 = async (): Promise<void> => {
    await waitForAmplitudeInitialization();

    pushCrossPseudoIdToGtag(getCrossPseudoId() ?? null);

    onCrossPseudoIdChange(pushCrossPseudoIdToGtag);
};
import {getCrossPseudoId, onCrossPseudoIdChange, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {gtag} from "./gtag";

const pushCrossPseudoIdToGtag = (crossPseudoId: string | null): void => {
    gtag("set", "user_properties", {cross_pseudo_id: crossPseudoId});
};

export const syncCrossPseudoIdWithGa4 = async (): Promise<void> => {
    await waitForAmplitudeInitialization();

    pushCrossPseudoIdToGtag(getCrossPseudoId() ?? null);

    onCrossPseudoIdChange(pushCrossPseudoIdToGtag);
};
